import { type Page_SlugCompanyQuery } from '#app/__generated__/relay/Page_SlugCompanyQuery.graphql.js';
import { CompanyProfileLayoutV2 } from '#app/components/companyProfilesV2/components/CompanyProfileLayoutV2/CompanyProfileLayout.js';
import { NotFound } from '#app/components/NotFound/NotFound.js';
import { type PageProps } from '#app/types/router.js';
import { graphql, usePreloadedQuery } from '@contra/relay';

type CompanyProfilePageProps = PageProps<
  '/company/@slug',
  Page_SlugCompanyQuery
>;

export const Page = ({ preloaded }: CompanyProfilePageProps) => {
  const { organizationBySlug } = usePreloadedQuery<Page_SlugCompanyQuery>(
    graphql`
      query Page_SlugCompanyQuery(
        $slug: String!
        $publicMembersFirst: Int = 5
      ) {
        organizationBySlug(slug: $slug) {
          id
          ...CompanyProfileLayoutV2_organization
        }
      }
    `,
    preloaded,
  );

  if (!organizationBySlug?.id) return <NotFound />;

  return <CompanyProfileLayoutV2 organizationRef={organizationBySlug} />;
};
